export const BLAPP_PROVIDER_KEY = '581f569b-7a3b-46ae-87db-cbe55c38abf2';
